import { render, staticRenderFns } from "./SchoolDefaulterReports.vue?vue&type=template&id=83fe6d18&"
import script from "./SchoolDefaulterReports.vue?vue&type=script&lang=js&"
export * from "./SchoolDefaulterReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports